export const defaultOptions = {
  retry: {
    limit: 5,
    methods: ["delete", "get", "head", "options", "post", "put", "trace"],
  },
};
